<template>
  <div
    :style="{...sizeStyle, ...customStyle}"
    @click="onClick"
  >
    <div :style="[sizeStyle,{overflow:'hidden' }]">
      <hy-image
        :custom-style="sizeStyle"
        :resize-mode="'cover'"
        :src="srcComputed"
        :placehold="defaultAvatar"
        :loading-img="loadingImg"
      />
    </div>
    <div
      v-if="iconDecoType"
      :style="[sizeDecoBgStyle]"
    >
      <img
        :style="sizeDecoStyle"
        :src="iconDecoType"
        alt=""
      >
    </div>
  </div>
</template>

<script>
import StyleSheet from '@/components/basic/StyleSheet';
import imageAvatarDefault from '@/assets/img/avatar_placehold.png';
import imageAvatarLoading from '@/assets/img/avatar_loading.png';
import imageIconVBlue from '@/assets/img/icon_blue_v.png';
import imageIconVOrange from '@/assets/img/icon_yello_v.png';
import imageIconStarBlue from '@/assets/img/icon_blue_p.png';
import imageIconStarOrange from '@/assets/img/icon_yello_p.png';
import HyImage from '@/components/basic/Image';
// const variables = StyleSheet.variables
const styles = StyleSheet.create({
  // avatar: { position: 'relative',},
});

export default {
  name: 'HyAvatar',
  components: { HyImage },
  props: {
    src: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 's',
    },
    accountType: {
      type: Number,
      default: 0,
    },
    vipType: {
      type: Number,
      default: 0,
    },
    customStyle: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      styles,
    };
  },
  computed: {
    srcComputed() {
      return decodeURIComponent(this.src) || imageAvatarDefault;
    },
    defaultAvatar() {
      return imageAvatarDefault;
    },
    loadingImg() {
      return imageAvatarLoading;
    },
    sizeStyle() {
      let w = 0;
      let h = 0;
      switch (this.size) {
        case 'xxl':
          h = 75;
          w = h;
          break;
        case 'xl':
          h = 60;
          w = h;
          break;
        case 'l':
          h = 50;
          w = h;
          break;
        case 'm':
          h = 40;
          w = h;
          break;
        case 's':
          h = 30;
          w = h;
          break;
        case 'xs':
          h = 20;
          w = h;
          break;
        default:
          break;
      }
      return {
        width: this.calcNum(w),
        height: this.calcNum(h),
        borderRadius: this.calcNum(w / 2),
        position: 'relative',
      };
    },
    sizeDecoBgStyle() {
      let w = 0;
      let h = 0;
      switch (this.size) {
        case 'xxl':
          h = 20;
          w = h;
          break;
        case 'xl':
        case 'l':
        case 'm':
          h = 16;
          w = h;
          break;
        case 's':
          h = 12;
          w = h;
          break;
        case 'xs':
          h = 0;
          w = h;
          break;
        default:
          break;
      }
      return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: this.calcNum(w),
        height: this.calcNum(h),
        borderRadius: this.calcNum(w / 2),
        backgroundColor: '#fff',
      };
    },
    sizeDecoStyle() {
      let w = 0;
      let h = 0;
      switch (this.size) {
        case 'xxl':
          h = 20;
          w = h;
          break;
        case 'xl':
        case 'l':
        case 'm':
          h = 16;
          w = h;
          break;
        case 's':
          h = 12;
          w = h;
          break;
        case 'xs':
          h = 0;
          w = h;
          break;
        default:
          break;
      }
      return {
        width: this.calcNum(w),
        height: this.calcNum(h),
        borderRadius: this.calcNum(w / 2),
        backgroundColor: '#fff',
      };
    },
    iconDecoType() {
      if (Number(this.vipType) === 1) {
        return {
          1: imageIconVBlue, // 官方一级账号
          2: imageIconVBlue, // 官方二级账号
          3: imageIconStarBlue, // 官方个人账号
          4: imageIconVOrange, // 媒体企业
          5: imageIconStarOrange, // 媒体个人
        }[Number(this.accountType)] || '';
      }
      return '';
    },
  },
  methods: {
    onClick(e) {
      this.$emit('click', e);
    },
  },
};
</script>
